import { useContext } from 'react'
import BlickBitesFastlaneContext, {
  BlickBitesFastlaneContextType,
} from '@contexts/blickBitesFastlaneContext'

const useBlickBitesFastlaneContext = (): BlickBitesFastlaneContextType =>
  useContext(BlickBitesFastlaneContext)

export default useBlickBitesFastlaneContext
